<template>
  <input-money
    id="offer-loan-amount"
    name="offer-loan-amount"
    class="offerLoanAmount"
    :strict-mode="{ regex: /[^0-9]/g, skipDefault: true }"
    :maxlength="OFFER_LOAN_AMOUNT_MAX_LENGTH"
    v-model="amount"
    @blur="onBlur"
  >
    <template #prefix>{{ $t('currency.dollar') }}</template>
  </input-money>
</template>
<script>
import money from '@/filters/money';
import { OFFER_LOAN_AMOUNT_MAX_LENGTH } from '@/modules/validation-service/fields-length';

export default {
  name: 'amount-incrementer',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    step: {
      type: Number,
      default: 1000,
    },
    amounts: {
      type: Array,
      default: () => [],
    },
    renewalPayoffAmount: {
      type: [Number, String],
      required: true,
    },
    payoffAmount: {
      type: [Number, String],
      required: true,
    },
    isRenewal: {
      type: Boolean,
      default: false,
    },
    isSplit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amount: this.value,
      OFFER_LOAN_AMOUNT_MAX_LENGTH,
      MINIMUM_LOAN_AMOUNT: 10000,
    };
  },
  computed: {
    max() {
      return Math.max(...this.amounts);
    },
    min() {
      return Math.min(...this.amounts);
    },
  },
  methods: {
    onBlur() {
      let { amount } = this;
      amount = Math.floor(amount / this.step) * this.step;
      if (this.isRenewal || this.isSplit) {
        const sum = this.renewalPayoffAmount + this.payoffAmount + this.MINIMUM_LOAN_AMOUNT;
        if (amount <= sum) {
          this.amount = this.calcAmount(sum);
          if (
            this.amount - this.renewalPayoffAmount - this.payoffAmount <
            this.MINIMUM_LOAN_AMOUNT
          ) {
            this.amount = this.calcAmount(this.amount + this.step);
          }
        } else if (amount >= this.max) {
          this.amount = this.max;
        } else {
          this.amount = this.calcAmount(amount);
        }
      } else if (amount <= this.min) {
        this.amount = this.min;
      } else if (amount >= this.max) {
        this.amount = this.max;
      } else {
        this.amount = this.calcAmount(amount);
      }
      this.$emit('input', this.amount);
    },
    calcAmount(val) {
      const closest = this.amounts.reduce((prev, curr) => {
        return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
      });
      return closest;
    },
  },
  filters: { money },
};
</script>

<style lang="sass" scoped>
::v-deep
  .inputContainer
    padding-left: baseunit(2.4) !important
  .prefix
    left: baseunit(0.4)
  #offer-loan-amount
    z-index: 999
</style>
